// The polarity-scale block: the chart over its sub-questions and where each of them landed on the
// scale, as a list. It offers no view strip -- there is one view to draw, so there is nothing to
// pick. Every sub-question is drawn as a question of its own below it.

import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'

import Items from '@aytm/app/stats/page/question-views/mx/components/items/Items'
import Chart from '@aytm/app/stats/page/question-views/mx/components/chart/Chart'
import ChartPlaceholder from '@aytm/app/stats/page/question-views/components/charts/placeholders/Chart'
import ItemsControls from '@aytm/app/stats/page/question-views/components/controls/Controls'
import { BlockContent as OeBlock } from '@aytm/app/stats/page/question-views/oe/Block'
import Table from '@aytm/app/stats/components/data-views/table/components/Table'

import { MATRIX_BLOCK_PROP_TYPES } from '@aytm/app/stats/page/question-views/mx/lib/prop-types'
import { calcScaleTableProps } from '@aytm/app/stats/page/question-views/mx/lib/table-utils'
import useMatrixBlock from '@aytm/app/stats/page/question-views/mx/states/useMatrixBlock'
import BlockWrapper from '@aytm/app/stats/page/question-views/components/BlockWrapper'

const Block = props => {
  const { answer, components } = props

  const surfaces = useMatrixBlock(props)

  // a scale reads its sub-questions the one way, so the list is there whatever is on screen
  const table = calcScaleTableProps(surfaces.tableInputs)

  // the sub-question list closes the block, so the response count sits under it rather than under
  // the summary; a block drawing no list carries the count itself
  const itemsOn = isComponentOn(components, 'subQuestions')

  // The reference link and the line closing the block -- the response count, or the footer standing
  // in for it -- belong to whichever half draws last. A block whose summary is off hands them to the
  // list rather than opening an empty section above it just to hold them.
  const closingProps = surfaces.summaryOn ? { answer, footer: props.footer } : props

  return (
    <>
      {surfaces.summaryOn ? (
        <BlockWrapper {...props}>
          <ItemsControls {...surfaces.itemsControlsProps} />

          {surfaces.isWCType && surfaces.isWordCloud ? (
            <OeBlock {...surfaces.cloudProps} />
          ) : (
            <>
              {isComponentOn(components, 'chart') && surfaces.chartOn ? (
                <ChartPlaceholder isLoading={'loading' === answer}>
                  <Chart {...surfaces.chartProps} />
                </ChartPlaceholder>
              ) : null}

              {isComponentOn(components, 'table') ? <Table {...table} /> : null}
            </>
          )}
        </BlockWrapper>
      ) : null}

      {itemsOn || !surfaces.summaryOn ? (
        <BlockWrapper {...closingProps}>
          {itemsOn ? <Items {...surfaces.batchesProps} onToggle={surfaces.onBatchToggle} /> : null}
        </BlockWrapper>
      ) : null}
    </>
  )
}

Block.displayName = 'PolarityScaleBlock'

Block.propTypes = MATRIX_BLOCK_PROP_TYPES

export default Block
